/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { httpClient } from "../../services";
import { ACTION_ENDPOINTS } from "../../constants";
export function addRemoteActions(objectType, setCurrentActionName, setIdExportModalOpen, setIdsWithReqNotMet, setLoading, idsWithReqNotMet, completeAction, actions = [], baseUrl) {
    const runAction = async (actionName, ids) => {
        setLoading(true);
        try {
            setCurrentActionName(actionName);
            const itemRequirements = await checkActionHasExportCriteria(actionName);
            if (Object.keys(itemRequirements).length === 0) {
                await completeAction(actionName, ids);
            }
            else {
                const allItemsMeetCriteria = await checkIdsMeetCriteria(ids, itemRequirements);
                if (!allItemsMeetCriteria) {
                    setIdExportModalOpen(true);
                }
                else {
                    await completeAction(actionName, ids);
                }
            }
        }
        catch (error) {
            console.error("Error running action", error);
        }
        finally {
            setLoading(false);
        }
    };
    const checkActionHasExportCriteria = async (actionName) => {
        try {
            const res = await httpClient().get(`/local/${ACTION_ENDPOINTS.GET_ACTIONS}`, {
                params: {
                    filter: {
                        and_: {
                            name: { eq: { value: actionName } },
                        },
                    },
                },
            });
            const requirements = 
            // @ts-ignore
            res.data.data[0]["attributes"]["params"]["requirements"] || {};
            return requirements;
        }
        catch (error) {
            console.error("Error fetching data for checking action requirements", error);
            setLoading(false);
            return {};
        }
    };
    const checkIdsMeetCriteria = async (ids, itemRequirements) => {
        try {
            const failedRequirementsMap = {};
            if (Object.keys(itemRequirements).length === 0) {
                return true;
            }
            for (const [field, conditionStr] of Object.entries(itemRequirements)) {
                const condition = JSON.parse(conditionStr.replace(/'/g, '"'));
                const filter = {
                    and_: {
                        id: { in_list: { value: ids } },
                        [field]: condition,
                    },
                };
                const res = await httpClient().get(`/${objectType}`, {
                    baseURL: baseUrl,
                    params: { filter: filter },
                });
                //@ts-ignore
                const data = res.data.data;
                const failedIds = ids.filter((id) => !data.map((item) => item.id).includes(id));
                if (failedIds.length > 0) {
                    failedRequirementsMap[field] = failedIds;
                }
            }
            const allFailingIds = Array.from(new Set(Object.values(failedRequirementsMap).flat()));
            if (allFailingIds.length === 0) {
                return true;
            }
            setIdsWithReqNotMet({
                ...idsWithReqNotMet,
                _failureDetails: failedRequirementsMap,
            });
            return false;
        }
        catch (error) {
            console.error("Error fetching data for checking action requirements", error);
            setLoading(false);
            return false;
        }
    };
    const convertStringAction = (name) => {
        return {
            name: name,
            action: (ids) => runAction(name, ids),
        };
    };
    const convertAction = (action) => {
        return typeof action === "string" ? convertStringAction(action) : action;
    };
    return actions?.map(convertAction);
}
